<template>
  <div class="container">
    <div class="langTabBox">
      <div
        :class="prizeStatus == 1 ? 'active' : ''"
        @click.stop="typePrizeClick(1)"
      >
        照明类奖项设置
      </div>
      <div
        :class="prizeStatus == 2 ? 'active' : ''"
        @click.stop="typePrizeClick(2)"
      >
        数智类奖项设置
      </div>
    </div>
    <div v-if="prizeStatus == 1">
      <div class="langBox">
        语言切换：
        <div
          :class="langLStatus == 1 ? 'active' : ''"
          @click.stop="typeLLangClick(1)"
        >
          中文
        </div>
        |
        <div
          :class="langLStatus == 2 ? 'active' : ''"
          @click.stop="typeLLangClick(2)"
        >
          English
        </div>
      </div>
      <div v-if="langLStatus == 1">
        <div class="charterTitle">
          对于产品奖、设计奖、工程奖进行小类细分，奖项细分如下:
        </div>
        <van-collapse
          v-model="activeNameAs"
          @change="onAChange"
          :border="false"
          custom-class="pb_collapse"
        >
          <van-collapse-item title="1、产品奖（2）" name="1" :border="false">
            <p class="pb_text">
              ①成品类：
1) 光源类成品（LED灯泡、LED灯管、农业照明、紫外照明）
2) 固定式灯具（吊灯及天花板或墙壁上电器照明装置）
3) 可移动式灯具（台灯、落地灯、床头灯等）
4) 节日灯饰、灯带、灯串
5) 户外灯具（户外用的路灯、投光灯、庭院灯、草坪灯、洗墙灯等）
6) 特种照明产品（影视舞台灯、工矿灯、水族灯、体育馆等专业场所使用的灯具）
7) 光显产品（各类显示屏、激光投影等）
8) 光伏产品（各类太阳能灯具）
9) 其他
②核心材料类：
1) 灯珠
2) 电源
3) 其他
            </p>
          </van-collapse-item>
          <van-collapse-item title="2、设计奖（12）" name="2" :border="false">
            <p class="pb_text">
              ①数字艺术：裸眼3D、影视特效、AR/VR数字互动、数字交互
②光艺术装置：艺术灯光装置具有雕塑艺术性及灯光艺术性，利用声、光、电的美学创作
③灯具造型设计：具有特色的灯具设计
④教育空间光环境设计：高等院校、职业院校、中小学、幼儿园、教育机构等校园办公及宿舍等具备文化教育功能的公共空间的照明设计方案。
⑤办公空间光环境设计：各类办公场所，包括总部大楼、现代服务机构营业场所、小型办公、共享办公等空间的照明设计方案。
⑥居住空间光环境设计：别墅、大平层、公寓、集合住宅等居住空间的照明设计方案。
⑦商业空间光环境设计：商场、专卖店、零售商店、美发中心、书店、展厅或不同于零售店的产品、服务宣传展示场所，包括房地产营销中心、会展搭建的临时展销厅等各种商业展陈空间的照明设计方案。
⑧酒店&文娱空间光环境设计：1）文娱空间：酒吧、夜总会、俱乐部、影视、游艺、音乐厅、影剧院、体育馆等文化、体育、娱乐场所的照明设计方案。2）酒店休闲空间：各类酒店室内空间、会所、水疗中心、SPA、主题餐厅、酒楼、特色风味餐厅、连锁餐饮等餐饮休闲场所的照明设计方案。
⑨康养医疗空间光环境设计：医院、养老院、养老机构、康复中心、疗养院、月子中心等空间的照明设计方案。
⑩城市&景观照明设计：1）都市、社区景观：城市公园、广场、街区、河道、桥梁、庭院景观、社区花园景观、社区开放空间等公共环境景观的照明设计方案。2）生态景观：风景区、自然生态保护区等景观的照明设计方案。
⑪建筑外立面照明设计：1）商业建筑：购物中心、商业街区、酒店、餐饮、娱乐类建筑等。 2）公共建筑：办公楼、科技园、城市综合体、交通建筑、体育建筑、会展建筑、博物馆、美术馆、图书馆、文化馆、文化艺术中心、展演类建筑、高等院校、职业院校、中小学、幼儿园等校园及宿舍等公共建筑的照明设计方案。
⑫文旅照明设计：1）故居、纪念园、博物馆类的照明设计方案。2）宗教古寺、庙宇类的照明设计方案。3）古镇古街、旅游小镇类的照明设计方案。4）史前遗址、古代设施类的照明设计方案。5）文化主题公园、文化产业园、文化新区类的照明设计方案。 </p>
          </van-collapse-item>
          <van-collapse-item title="3、工程奖（6）" name="3" :border="false">
            <p class="pb_text">
              ①商业建筑景观照明工程：以商业建筑，包括：商店、商场、批发市场、商业综合体；办公写字楼、销售展示中心；旅馆（含宾馆、酒店、招待所等）；餐馆（含中西餐厅、饮食店、酒吧等）；文化娱乐设施（如卡拉OK歌舞厅等）、会所等为主，体现建筑外立面照明效果。
②公共建筑景观照明工程：以政府出资建造的公共建筑（一般指规划区内的各种行政建筑、服务民众的建筑等，包括政府建筑、公共娱乐设施、城市交通设施、教育科研文化机构建筑、医疗卫生机构建筑等）为主，体现建筑外立面照明效果。
③城市景观照明工程：1）都市、社区景观：城市公园、广场、街区、河道、桥梁、庭院景观、社区花园景观、社区开放空间等公共环境景观的照明工程。2）生态景观：风景区、自然生态保护区等景观的照明工程。
④文旅照明工程：1）故居、纪念园、博物馆类的照明工程。2）宗教古寺、庙宇类的照明工程。3）古镇古街、旅游小镇类的照明工程。4）史前遗址、古代设施类的照明工程。5）文化主题公园、文化产业园、文化新区类的照明工程。
⑤商业建筑室内照明工程：以商业建筑，包括：商店、商场、批发市场、商业综合体；办公写字楼、销售展示中心；旅馆（含宾馆、酒店、招待所等）；餐馆（含中西餐厅、饮食店、酒吧等）；文化娱乐设施（如卡拉OK歌舞厅等）、会所等为主，体现室内照明效果。
⑥公共建筑室内照明工程：以政府出资建造的公共建筑（一般指规划区内的各种行政建筑、服务民众的建筑等，包括政府建筑、公共娱乐设施、城市交通设施、教育科研文化机构建筑、医疗卫生机构建筑等）为主，体现室内照明效果。
    </p>
          </van-collapse-item>
          <van-collapse-item
            title="4、创新融合奖（与其他机构联合办奖）"
            name="4"
            :border="false"
          >
            <!-- <div class="pb_text">
              <div>4.1、 阿拉丁神灯奖——设计曙光奖（院校）</div>
              <div>①光艺术装置</div>
              <div>②灯具造型创意设计</div>
              <div style="margin-bottom: 30rpx">③光环境艺术设计</div>

              <div style="margin-bottom: 30rpx">
                4.2 、阿拉丁神灯奖——雅江创意照明奖 更多奖项详情请<span
                  style="color: blue; font-weight: bold"
                  @click="toDetails(1)"
                  >点击</span
                >
              </div>

              <div>
                4.3、阿拉丁神灯奖——照明细分领域出口企业50强 更多奖项详情请<span
                  style="color: blue; font-weight: bold"
                  @click="toDetails(2)"
                  >点击</span
                >
              </div>
              <div>
                ①成品类--光源类成品（白炽灯泡、卤钨灯、荧光灯、HID灯、LED灯泡、LED灯管）
              </div>
              <div>②成品类--固定式灯具（吊灯及天花板或墙壁上电器照明装置）</div>
              <div>③成品类--可移动式灯具（台灯、落地灯、床头灯等）</div>
              <div>④成品类--圣诞灯具（圣诞树用的成套灯具）</div>
              <div>⑤成品类--户外及显示灯具（户外用的路灯、投光灯等）</div>
              <div>⑥成品类--特种照明产品（影视舞台灯、工矿灯、水族灯等）</div>
              <div>⑦核心材料类--电源</div>
              <div>⑧核心材料类--灯珠</div>
              <div>⑨核心材料类--电子料</div>
              <div>⑩核心材料类--结构件--光源结构件</div>
              <div>⑪核心材料类--结构件--灯具结构件</div>
              <div style="margin-bottom: 30rpx">
                ⑫核心材料类--结构件--软硬基板
              </div>

              <div>
                4.4、阿拉丁神灯奖——智能照明生态百强榜 更多奖项详情请<span
                  style="color: blue; font-weight: bold"
                  @click="toDetails(3)"
                  >点击</span
                >
              </div>
              <div>
                ①泛商业空间:包含商业综合体、机场、地铁、商业店铺、办公空间、公共空间等
              </div>
              <div>②酒店</div>
              <div>③校园</div>
              <div>④住宅</div>
            </div> -->
          </van-collapse-item>
          <van-collapse-item title="5、评审规则" name="5" :border="false">
            <p class="pb_text">
              5.1、
              每一个小类别都组建专业评审组，评审团成员采取规避原则，即所在单位如果参与某一小分类申报，则自动取消该类别的投票资格。
              5.2、从每一个小分类中选出若干个优秀奖，优秀奖的获奖比例不超过申报数量的20%，最佳奖获奖比例不超过优秀奖的40%。当某类别申报不足的情况下，由该小类别专业评审组来讨论相应的解决办法，如取消该类别的优秀提名奖。每一个大类别的突出奖项，不需要进行特别申报，终审委员会将从所有小类优秀奖里面，特别进行评分，从而评选完成。
              5.3、企业或个人的申报项目总数，不能超过6个；申报同一奖项分类的项目，不能为同一名称的不同款式。
              5.4、评分制度：以分数为评判，以分数高低进行排名。
            </p>
          </van-collapse-item>
          <van-collapse-item title="6、异议处理" name="6" :border="false">
            <p class="pb_text">
              组委会秘书处在阿拉丁网上照明展、阿拉丁神灯奖官网上公示优秀奖获奖名单，任何单位或者个人对候选优秀奖项目的创新性、先进性、实用性及推荐材料真实性等持有异议的，应当在公示之日起7日内向组委会秘书处提出，逾期不予受理。
              6.1、提出异议的单位或者个人应当提供书面异议材料，并提供必要的证明文件。
              提出异议的单位、个人应当表明真实身份。个人提出异议的，应当在书面异议材料上签署真实姓名；以单位名义提出异议的，应当加盖本单位公章。以匿名方式提出的异议一般不予受理。
              6.2、
              提出异议的单位、个人不得擅自将异议材料直接提交评审组织或者其委员；委员收到异议材料的，应当及时转交组委会秘书处，不得提交评审组织讨论和转发其他委员。
              6.3
              组委会秘书处在接到异议材料后应当进行审查，对符合规定并能提供充分证据的异议，应予受理。
              6.4、为维护异议者的合法权益，组委会秘书处、推荐单位及其工作人员和推荐人，以及其他参与异议调查、处理的有关人员应当对异议者的身份予以保密；确实需要公开的，应当事前征求异议者的意见。
              6.5、涉及优秀奖项目的创新性、先进性、实用性及推荐材料真实性等内容的异议由组委会秘书处负责协调，由有关推荐单位或者推荐人协助。推荐单位或者推荐人接到异议通知后，应当在规定的时间内核实异议材料，并将调查、核实情况报送组委会秘书处审核。必要时，组委会秘书处可以组织专业评审组进行调查，提出处理意见。
              推荐单位或者推荐人接到异议材料后，在异议通知规定的时间内未提出调查、核实报告和协调处理意见的，该项目不提交评审。
              6.6、异议处理过程中，涉及异议的任何一方应当积极配合，不得推诿和延误。候选优秀项目在规定时间内未按要求提供相关证明材料的，视为承认异议内容；提出异议的单位、个人在规定时间内未按要求提供相关证明材料的，视为放弃异议。
              6.7、异议自异议受理截止之日起10日内处理完毕.
              6.8、组委会秘书处应当向相关的专业评审委员会报告异议核实情况及处理意见，提请终审委员会决定，并将决定意见通知异议方和推荐单位、推荐人。
              组委会秘书处应当及时向评审团报告异议处理情况。
            </p>
          </van-collapse-item>
        </van-collapse>
      </div>
      <div v-if="langLStatus == 2">
        <div class="charterTitle">
          The awards for product, technology, project and innovation are
          subdivided into the following categories:
        </div>
        <van-collapse
          v-model="activeNameBs"
          bind:change="onBChange"
          :border="false"
          custom-class="pb_collapse"
        >
          <van-collapse-item
            title="1.Product Awards (2 sub categories)"
            name="1"
            :border="false"
          >
            <p class="pb_text">
              ①Finished Products: 1)Light source products (LED bulbs, LED tubes,
              agricultural lighting, UV lighting) 2)Fixed lights (pendant light
              and electrical lighting device on ceiling or wall) 3)Movable
              lights (table light, floor light, bedside light, etc.) 4）Festival
              lights, light strips, light strings 5) Outdoor lights (outdoor
              street lights, project lights, garden lights, lawn lights, wall
              washing lights, etc.) 6) Special lighting products (lights used in
              film and television stage lights, industrial and mining lights,
              aquarium lights, gymnasiums and other special places) 7) Optical
              display products (various displays, laser projection, etc.) 8)
              Photovoltaic products (all kinds of solar lights) 9) Other
              products ②Core material products: 1)light beads 2)light source
              3)other material
            </p>
          </van-collapse-item>
          <van-collapse-item
            title="2.Design Awards (12 sub categories)"
            name="2"
            :border="false"
          >
            <p class="pb_text">
              ①Digital Art: naked 3D, film and television special effects, AR/VR
              digital interaction, digital interaction ②Light Art Installation:
              art light installation has sculpture artistry and light artistry
              which uses the aesthetics of sound, light and electricity in
              creation ③Design of Lamp Modeling: feature lamp design ④Design of
              Light Environment in Educational Space: lighting design scheme for
              campus offices and dormitories of colleges and universities,
              vocational colleges, primary and secondary schools, kindergartens,
              educational institutions and other public spaces with cultural and
              educational functions. ⑤Design of Light Environment in Working
              Space: lighting design scheme for various office spaces, including
              headquarters building, business premises of modern service
              institutions, small office, shared office and other spaces.
              ⑥Design of Light Environment in Living Space: lighting design
              scheme for villas, large flat floors, apartments, assembly houses
              and other living spaces. ⑦Design of Light Environment in Business
              Space: lighting design scheme for shopping malls, exclusive
              stores, retail stores, hair salons, bookstores, exhibition halls
              or places for product and service publicity and display different
              from retail stores, including real estate show rooms, temporary
              exhibition halls built for exhibitions and other commercial
              exhibition spaces. ⑧Design of Light Environment in Hotels and
              Entertainment Space: 1) Entertainment Space: lighting design
              scheme of bars, night clubs, clubs, movies, game centers, concert
              halls, cinemas and other cultural and entertainment places. 2)
              Hotel Leisure Space: lighting design scheme for various hotel
              interior spaces, clubs, SPA, theme restaurants, restaurant,
              specialty canteens, chain restaurants and other catering and
              leisure places. ⑨Design of Light Environment in Health Care and
              Medical Space: lighting design scheme for hospital, nursing home,
              nursing institution, rehabilitation center, sanatorium, maternity
              centers and other spaces. ⑩Urban and Landscape Lighting Design: 1)
              Urban and Community Landscape: lighting design scheme of public
              environment landscape such as urban park, square, block, river,
              bridge, courtyard landscape, community garden landscape, community
              open space, etc. 2) Ecological Landscape: lighting design scheme
              for scenic spots, natural ecological reserves and other
              landscapes. ⑪External Façade Lighting Design: 1) Commercial
              Buildings: shopping centers, commercial blocks, hotels, catering,
              entertainment building, etc. 2) Public Building: lighting design
              scheme for office buildings, science and technology parks, urban
              complexes, transportation buildings, sport buildings, exhibition
              buildings, museums, art galleries, libraries, cultural centers,
              cultural and art centers, exhibition buildings, colleges and
              universities, vocational colleges, primary and secondary schools,
              kindergartens and other public buildings. ⑫Cultural Tourism
              Lighting Design: 1) Lighting design scheme for former residences,
              memorial parks and museums; 2) lighting design scheme for ancient
              religious temples and courts; 3) lighting design scheme for
              ancient streets and tourist towns; 4) lighting design scheme for
              prehistoric sites and ancient facilities; 5) lighting design
              scheme for cultural theme parks, cultural industrial parks and
              cultural new areas.
            </p>
          </van-collapse-item>
          <van-collapse-item
            title="3.Project Awards (6 sub categories)"
            name="3"
            :border="false"
          >
            <p class="pb_text">
              ①Commercial Building Landscape Lighting Project: commercial
              buildings, including shops, shopping malls, wholesale markets and
              commercial complexes; office buildings and sales exhibition
              centers; hotels including inns, hotel, guest house, etc.
              restaurants including Chinese and western restaurants, snack bars,
              bars, etc. cultural and entertainment facilities, such as karaoke
              dance halls, clubs which mainly reflect the lighting effect of the
              building façade. ②Public Building Landscape Lighting Project:
              Public buildings funded by the government (generally referring to
              various administrative buildings and buildings serving the public
              in the planning area, including government buildings, public
              entertainment facilities, urban transportation facilities,
              education, research and cultural institutions, medical and health
              institutions, etc.) are mainly used to reflect the light effect of
              the building façade. ③Urban Landscape Lighting Project: 1) urban
              and community landscape: urban park, square, block, river, bridge,
              courtyard landscape, community garden landscape, community open
              space and other public environmental landscape lighting projects.
              2) Ecological lands: lighting projects for scenic spots, natural
              ecological reserves and other landscapes. ④Cultural Tourism
              Lighting Project: 1) Lighting design scheme for former residences,
              memorial parks and museums; 2) lighting design scheme for ancient
              religious temples and courts; 3) lighting design scheme for
              ancient streets and tourist towns; 4) lighting design scheme for
              prehistoric sites and ancient facilities; 5) lighting design
              scheme for cultural theme parks, cultural industrial parks and
              cultural new areas. ⑤Commercial Building Interior Lighting
              Project: commercial buildings, including shops, shopping malls,
              wholesale markets and commercial complexes; office buildings and
              sales exhibition centers; hotels including inns, hotel, guest
              house, etc. restaurants including Chinese and western restaurants,
              snack bars, bars, etc. cultural and entertainment facilities, such
              as karaoke dance halls, clubs which mainly reflect the lighting
              effect of the building façade. ⑥Public Building Indoor Lighting
              Project: Public buildings funded by the government (generally
              referring to various administrative buildings and buildings
              serving the public in the planning area, including government
              buildings, public entertainment facilities, urban transportation
              facilities, education, research and cultural institutions, medical
              and health institutions, etc.) are mainly used to reflect the
              light effect of the building façade.
            </p>
          </van-collapse-item>
          <van-collapse-item
            title="4.Design Award (Cooperated with other institutions)"
            name="4"
            :border="false"
          >
            <p class="pb_text"></p>
          </van-collapse-item>
          <van-collapse-item
            title="5.Evaluation Rules"
            name="5"
            :border="false"
          >
            <p class="pb_text">
              5.1 Each subcategory shall establish a professional jury and the
              members of the jury shall adopt the principle of circumvention,
              that is, if his institution participates in the application of one
              subcategory, his voting qualification of the category will be
              automatically cancelled. 5.2 Several Excellent Awards shall be
              selected from each sub category and the proportion of which shall
              not exceed 20% of the application projects, while the proportion
              of Best Awards not exceeding 40% of the Excellent Awards. In case
              of insufficient application of a certain category, the
              professional jury of the sub category shall discuss corresponding
              solutions, such as canceling the excellent nomination award of the
              category. No special declaration is required for each major
              category of outstanding awards. The final jury committee will
              evaluate Excellent Awards from all sub categories and complete the
              selection. 5.3 The maximum number of projects applied by
              enterprises or individuals is 6; projects applying for the same
              award category shall not be different styles with the same name.
              5.4 Evaluation system: based on scores, ranking is based on
              scores.
            </p>
          </van-collapse-item>
          <van-collapse-item
            title="6、Dispute Settlement"
            name="6"
            :border="false"
          >
            <p class="pb_text">
              The secretariat of committee shall publicize the list of winner of
              excellent awards on Alighting.cn and Lamp Award official site. If
              any unit or individual has objection against the creativity,
              advancement and practicality of excellent award items or the
              truthfulness of recommended materials, they shall bring it up to
              the secretariat of committee within 7 days after the date of
              publicity. Objection overdue is not to be accepted. 6.1 Unit or
              individual raising the objection shall provide written objection
              materials and necessary documentary proof. Unit or individual
              raising the objection shall show their true identities. In case of
              objection raised by an individual, the real name shall be signed
              on the written material on the objection; in case of objection
              raised by a unit, the official seal of the unit shall be stamped.
              Objections raised anonymously are not accepted in general. 6.2
              Unit or individual raising the objection shall not arbitrarily
              submit the objection materials directly to the appraisal
              organization or its members; members shall pass the objection
              materials to the secretariat of committee in a timely manner after
              receiving them, but shall not submit them to the appraisal
              organization for discussion r pass them to other members. 6.3 The
              secretariat of committee shall audit the objection materials upon
              receiving them and accept the objection that complies with the
              rule with sufficient evidence. 6.4 To protect the lawful rights
              and interests of objection raisers, the secretariat of committee,
              recommending unit and their staffs and recommenders as well as
              other personnel participating in investigation and treatment of
              objection shall keep the identity of the objection raiser
              confidential; if disclosure is necessary, they shall ask the
              objection raiser for opinion in advance. 6.5 The secretariat of
              committee shall coordinate objection on creativity, advancement
              and practicality of items involved in excellent award and
              truthfulness of recommended materials, etc. under the help of the
              recommending unit or the recommender. The recommending unit or
              recommender shall verify the objection materials in time after
              receiving the notice, and submit the result of investigation and
              verification to the secretariat of committee for auditing. The
              secretariat of committee may organize professional appraisal team
              for investigation if necessary and raise treatment opinions. If
              the recommending unit or recommender fails to provide
              investigation and verification report and coordinated treatment
              opinion in time specified in the notice after receiving the
              objection materials, the item is not to be submitted for
              appraisal. 6.6 During objection handling, any party involved in
              the objection shall positively cooperate without shuffle and
              delay. If the nominee fails to provide relevant documentary proof
              required in time, it shall be deemed as agreeing to the objection;
              if the unit and individual raising the objection fail to provide
              documentary proof as required in time, they shall be deemed as
              relinquishing the objection. 6.7 Objection shall be handled within
              10 days by the deadline of objection acceptance 6.8 The
              secretariat of committee shall report the result of objection
              verification and the treatment opinions to the relevant
              professional appraisal committee, submit them to the final
              appraisal committee for decision-making, and inform the objection
              raiser, recommending unit and recommender of the opinions decided.
              The secretariat of committee shall report the handling of
              objection to the appraisal committee in a timely manner.
            </p>
          </van-collapse-item>
        </van-collapse>
      </div>
    </div>
    <div v-if="prizeStatus == 2">
      <div class="langBox">
        语言切换：
        <div
          :class="langIStatus == 1 ? 'active' : ''"
          @click.stop="typeILangClick(1)"
        >
          中文
        </div>
        |
        <div
          :class="langIStatus == 2 ? 'active' : ''"
          @click.stop="typeILangClick(2)"
        >
          English
        </div>
      </div>
      <div v-if="langIStatus == 1">
        <div class="charterTitle">
          对于数智成果奖、数智设计奖进行小类细分，奖项细分如下
        </div>
        <van-collapse
          v-model="activeNameCs"
          bind:change="onCChange"
          :border="false"
        >
          <van-collapse-item
            title="1、数智成果奖（2）"
            name="1"
            :border="false"
          >
            <p class="pb_text">
              ①智能家居:
1）家庭系统：背景音乐、家庭、影音共享、数字客厅等产品。
2）家庭安全系统：安防、监控、门禁、可视对讲等产品。
3）家电智能控制：灯光智能控制、智能家居控制系统、远程控制等产品。

②智慧建筑:
主要面向办公楼、商业综合楼、文化、媒体、学校、体育场馆、医院、交通、工业建筑、住宅小区等建筑的智能化产品。
            </p>
          </van-collapse-item>
          <van-collapse-item
            title="2、数智设计奖（2）"
            name="2"
            :border="false"
          >
            <p class="pb_text">
              ①智能家居
1）家庭系统设计方案（背景音乐、家庭、影音共享、数字客厅等）
2）家庭安全系统设计方案（安防、监控、门禁、可视对讲等）
3）家电智能控制设计方案（灯光智能控制、智能家居控制系统、远程控制等）
4）智能家居体验厅设计方案
5）全屋智能集成设计方案
6）商业空间集成设计方案

②智慧建筑
主要面向办公楼、商业综合楼、文化、媒体、学校、体育场馆、医院、交通、工业建筑、住宅小区等建筑的智能化设计方案。
            </p>
          </van-collapse-item>
        </van-collapse>
      </div>
      <div v-if="langIStatus == 2">
        <div class="charterTitle">
          The sub categories of Intelligent Product Awards and Intelligent
          Design Awards are subdivided as follows:
        </div>
        <van-collapse
          v-model="activeNameDs"
          @change="onDChange"
          :border="false"
          custom-class="pb_collapse"
        >
          <van-collapse-item
            title="1.Application Form of Digital Intelligence Achievement Award (2 sub categories)"
            name="1"
            :border="false"
          >
            <p class="pb_text">
              ①Smart Home:
1) home system: background music, home, video sharing, digital living room and other products;
2) home safety system: security, monitoring, entrance guard, visual intercom and other products;
3) intelligent control of household appliances: intelligent lighting control, intelligent household control system, remote control and other products.

②Smart Building:
intelligent products for office buildings, commercial complex building, culture, media, schools, hospitals, transportation, industrial buildings, residential areas and other building.
            </p>
          </van-collapse-item>
          <van-collapse-item
            title="2.Application Form of Digital Intelligence Design Award (2 sub categories)"
            name="2"
            :border="false"
          >
            <p class="pb_text">
              ① Smart Home:
1) Home system design scheme (background music, home, video sharing, digital living room, etc.)
2) Family safety system design scheme (security, monitoring, access control, visual intercom, etc.)
3) Intelligent control design scheme for household appliances (intelligent lighting control, intelligent home control system, remote control, etc.) 4) Design Scheme of smart home experience hall
5) Whole house intelligent integrated design scheme
6) Integrated design scheme for commercial space

②Smart Building:
intelligent design scheme for office buildings, commercial complex building, culture, media, schools, hospitals, transportation, industrial buildings, residential areas and other building.
            </p>
          </van-collapse-item>
        </van-collapse>
      </div>
    </div>
  </div>
</template>
<script>
import { Collapse, CollapseItem } from "vant";
export default {
  name: "setting",
  components: {
    "van-collapse": Collapse,
    "van-collapse-item": CollapseItem,
  },
  data() {
    return {
      prizeStatus: 1,

      langLStatus: 1,
      activeNameAs: ["1"],
      activeNameBs: ["1"],
      langIStatus: 1,
      activeNameCs: ["1"],
      activeNameDs: ["1"],
    };
  },
  methods: {
    toDetails(n) {
      if (n == 1) {
        window.location.href =
          "https://www.alighting.cn/special/2022YJ/index.htm";
      } else if (n == 2) {
        window.location.href =
          "https://www.alighting.cn/special/20211026/index.htm";
      } else if (n == 3) {
        window.location.href = "https://www.alighting.cn/special/HDL/index.htm";
      }
    },
    //奖项设置切换
    typePrizeClick(n) {
      this.langLStatus = 1;
      this.langIStatus = 1;
      this.prizeStatus = n;
      this.activeNameAs = ["1"];
      this.activeNameCs = ["1"];
    },

    //照明类语言切换
    typeLLangClick(n) {
      this.langLStatus = n;
    },

    //智能生态语言切换
    typeILangClick(n) {
      this.langIStatus = n;
    },

    onAChange(event) {
      this.activeNameAs = event;
    },

    onBChange(event) {
      this.activeNameBs = event;
    },

    onCChange(event) {
      this.activeNameCs = event;
    },

    onDChange(event) {
      this.activeNameDs = event.detail;
    },
  },
  mounted() {
    if (!this.Common._isMobile()) {
      window.location.href = "https://sdj.alighting.com/about.html";
    }
  },
};
</script>
<style scoped src="../../../static/css/setting.css">
</style>